import {
  collection,
  doc,
  addDoc,
  updateDoc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
  writeBatch,
  increment,
} from 'firebase/firestore';
import { db } from '../firebase';

export function listenToChats(callback) {
  const q = query(collection(db, 'chats'), orderBy('lastMessageAt', 'desc'));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function listenToMessages(chatId, callback) {
  const q = query(collection(db, 'chats', chatId, 'messages'), orderBy('createdAt', 'asc'));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function listenToChatMeta(chatId, callback) {
  return onSnapshot(doc(db, 'chats', chatId), (snap) => callback(snap.data()));
}

export async function sendAdminMessage(chatId, { text, imageBase64 }) {
  await addDoc(collection(db, 'chats', chatId, 'messages'), {
    sender: 'admin',
    text: text || '',
    imageBase64: imageBase64 || null,
    createdAt: serverTimestamp(),
    seenByAdmin: true,
    seenByUser: false,
  });

  await updateDoc(doc(db, 'chats', chatId), {
    lastMessageAt: serverTimestamp(),
    adminTyping: false,
  });
}

export function setAdminTypingFlag(chatId, typing) {
  return updateDoc(doc(db, 'chats', chatId), { adminTyping: typing }).catch(() => {});
}

export async function markUserMessagesSeenAndClearUnread(chatId, messages) {
  const unseen = messages.filter((m) => m.sender === 'user' && !m.seenByAdmin);

  if (unseen.length === 0) {
    await updateDoc(doc(db, 'chats', chatId), { unreadForAdmin: 0 });
    return;
  }

  const batch = writeBatch(db);
  unseen.forEach((m) => {
    batch.update(doc(db, 'chats', chatId, 'messages', m.id), { seenByAdmin: true });
  });
  batch.update(doc(db, 'chats', chatId), { unreadForAdmin: 0 });
  await batch.commit();
}

export { increment };